import { createMonthDateRange, DateRange } from 'owa-datetime-utils';
import { startOfWeek, addDays, isWithinRange, OwaDate } from 'owa-datetime';
import { DateRangeType, DayOfWeek } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';

/**
 * On initial page load, we want to front load some data so that switching between week/month view is very fast the first time, and going forward to
 * either the next week (week view) or the next month (month view) is also fast. We can do this by checking whether this is the very first load, and
 * always loading 2 months of data there.
 */

export default function calculateRequestRange(
    selectedDate: OwaDate,
    surfaceDateRange: DateRange,
    dateRangeType: DateRangeType,
    weekStartDay: DayOfWeek,
    initialLoad?: boolean
): DateRange {
    let requestRange: DateRange;

    let date = selectedDate;
    if (!isWithinRange(date, surfaceDateRange.start, surfaceDateRange.end)) {
        date = surfaceDateRange.start;
    }

    if (initialLoad) {
        // for the initial load, we load one month regardless of dateRangeType
        requestRange = createMonthDateRange(date, weekStartDay);
    } else {
        if (dateRangeType == DateRangeType.Month) {
            requestRange = createMonthDateRange(date, weekStartDay);
        } else {
            // for day, week, work week, we load the full week
            requestRange = {
                start: startOfWeek(date, weekStartDay),
                end: addDays(surfaceDateRange.end, 1),
            };
        }
    }

    return requestRange;
}
